import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../../environments/environment';
import { IDuplicatePropertyOutputModel } from '../../shared/models/DuplicatePropertyOutputModel';
import { Router } from '@angular/router';
import { ValidationService } from '../../shared/providers/validation.service';

@Component({
  selector: 'app-property-duplicates',
  templateUrl: './property-duplicates.component.html'
})
export class PropertyDuplicatesComponent implements OnInit {

    constructor(private http: HttpClient, private _propertyListingService: PropertyListingService, private modalService: BsModalService, private router: Router, private valdateService: ValidationService) {

    }
    dtOptions = {};
    table: DataTableDirective;
    @ViewChild(DataTableDirective) dtElement: DataTableDirective;
    protected readonly BASE_URL: string = environment.base_url;
    @Input() PropertyId: number = 0;
    @Input() Type: number = 0;
    duplicatePropertyList: IDuplicatePropertyOutputModel[];
    @Input() modalRef: BsModalRef;
    routeURL = '';
    ngOnInit() {
        this.routeURL = this.router.url.split('?')[0];
        const that = this;
        this.dtOptions = {
            pagingType: 'full_numbers',
            "pageLength": 50,
            serverSide: true,
            processing: true,
            info: false,
            language: {
                zeroRecords: null,
            },
            "order": [[0, "desc"]],
            bLengthChange: false,
            initComplete: () => $('.dataTables_filter').css('display', 'none'),
            ajax: (dataTablesParameters: any, callback: Function) => {
                $("#dtTableDuplicates thead").hide();
                const filter =
                    {
                        PropertyId: that.PropertyId,
                        Type: that.Type
                    }
                dataTablesParameters.Extra_param = filter;
                const httpHeader = this.valdateService.GetAuthHeader();
                that.http
                    .post<DataTablesResponse>(
                        this.BASE_URL + '/property/DuplicatePropertiesList',
                    dataTablesParameters, httpHeader
                    ).subscribe(resp => {
                        that.duplicatePropertyList = resp.data ? resp.data : [];
                      console.log(resp.data)
                        if (resp) {
                            callback({
                                recordsTotal: resp.recordsTotal,
                                recordsFiltered: resp.recordsFiltered,
                                data: []
                            });
                            if (resp.data.length === 0) {
                                $(".dataTables_paginate.paging_full_numbers").hide();
                            }
                            else {
                                $(".dataTables_paginate.paging_full_numbers").show();
                            }
                            $(".paginate_button.first,.paginate_button.last").hide();
                        } else {
                            callback({
                                recordsTotal: 0,
                                recordsFiltered: 0,
                                data: []
                            });
                            $(".dataTables_paginate.paging_full_numbers").hide();
                        }
                    });
            },
            columns: [{ data: 'TenantName' }]
        };
    }
    onSearch(text: string) {
        this.dtElement.dtInstance.then(x => x.search(text).draw());
    }

}
